import { PropsWithChildren } from "react";

export default function ActivityContentWrapper({
  children,
}: PropsWithChildren) {
  return (
    <div className="flex flex-col gap-2 justify-start items-start mt-1 flex-1">
      {children}
    </div>
  );
}
